import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';
import { getCommunitiesByIds, getCommunityById } from 'utils/helpers/communityMap';

import CommunityInfoCompetitorContent from './CommunityInfoCompetitorContent';
import CommunityInfoCompetitorMenu from './CommunityInfoCompetitorMenu';
import { CommunityType } from '../../types/communities';

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--line-gray);
  margin-top: -50px;
  padding-top: 50px;
  max-width: 250px;
`;

const Header = styled.div`
  padding-bottom: 10px;
  font-size: 14px;
  color: var(--text-primary);
  padding-left: 20px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const Title = styled.div`
  color: var(--text-primary);
  font-family: var(--font-bold);
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
`;

const Note = styled.div`
  color: var(--gray-dark);
  font-size: 14px;
  text-align: center;
`;

const CommunityInfoCompetitorOverview = () => {
  const { selectedCommunity, communityMap } = useAppSelector((state) => state.global);
  const community = getCommunityById(communityMap, selectedCommunity?.id);
  const competitors = getCommunitiesByIds(communityMap, community?.competitors).filter(
    (competitor: CommunityType) => !!competitor
  );

  const showInfo = !competitors?.length;

  return (
    <Container data-test-id="cd-community-info-competitor-overview">
      {showInfo ? (
        <Info data-test-id="cd-community-info-competitor-empty">
          <Title data-test-id="cd-community-info-competitor-empty-title">There are no competitors.</Title>
          <Note data-test-id="cd-community-info-competitor-empty-note">Please check at a later date for new competitors</Note>
        </Info>
      ) : (
        <>
          <Sidebar data-test-id="cd-community-info-competitor-sidebar">
            <Header data-test-id="cd-community-info-competitor-sidebar-title">Competitors</Header>
            <CommunityInfoCompetitorMenu competitors={competitors} />
          </Sidebar>
          <CommunityInfoCompetitorContent />
        </>
      )}
    </Container>
  );
};

export default CommunityInfoCompetitorOverview;
